jQuery(document).ready(function(){
    document.addEventListener('rebuy:smartcart.item-switch-to-subscription', (event) => {
      console.log("Switch");
      const smartcart = event.detail.smartcart;
      const item = event.detail.item;
      console.log("Item: ", item);
      const Cart = window.Rebuy.Cart;
      if(item.id == "49481630318905" && item.quantity == 2) {
        Cart.switchItemToFrequency(item, "Two bottles (15 servings each), shipped monthly • Cancel or pause anytime");
      }
    });
  
    document.addEventListener('rebuy:cart.change', (event) => {
      console.log("Cart changed", event.detail.cart.itemCount());

      let item_count = event.detail.cart.itemCount();
      console.log("Item count: ", item_count);
      document.getElementsByTagName("cart-count")[0].innerText = item_count;
    });
});